import { TransitionProvider } from '../context/TransitionContext';
import Header from '@/components/Header';
import TransitionComponent from '@/components/Transition';
import Page from '@/components/Page';
import WhatsappFloat from '@/components/WhatsappFloat';
import { useEffect } from 'react';
import { qsa } from '@/utils/common';
import { gsap } from 'gsap';
import ScrollTrigger from 'gsap/dist/ScrollTrigger';
import Menu from '@/components/Menu';
import { GoogleTagManager } from '@next/third-parties/google';
import {GoogleReCaptchaProvider} from "react-google-recaptcha-v3";
import { beVietnamPro, plusJakartaSans } from '@/utils/fonts';
import env from '@architecture-it/react-env';

gsap.registerPlugin(ScrollTrigger);

const Layout = ({ children, locale, hideNavBar = false }) => {
  useEffect(() => {
    qsa('.wrapper-enter').forEach((section) => {
      ScrollTrigger.create({
        trigger: section,
        onEnter: () => {
          section.classList.add('is-inview');
        }
      });
    });
  });

  return (
    <div className={`layout ${beVietnamPro.variable} ${plusJakartaSans.variable}`}>
      <GoogleTagManager gtmId={process.env.NEXT_PUBLIC_GOOGLE_TAG_MANAGER || env('GOOGLE_TAG_MANAGER')} />
      {!hideNavBar && <Header locale={locale} />}
      <TransitionProvider>
        <TransitionComponent>
            <GoogleReCaptchaProvider reCaptchaKey={process.env.NEXT_PUBLIC_RECAPTCHA_PUBLIC_KEY || env('RECAPTCHA_PUBLIC_KEY')}>
                <Page>{children}</Page>
            </GoogleReCaptchaProvider>
        </TransitionComponent>
      </TransitionProvider>
      <WhatsappFloat locale={locale} />
    </div>
  );
};

export default Layout;
